<template>
  <div class="sidebar">
      <div class="sidebar__topbar">
        <button class="collapse-btn" type="button" @click="$emit('toggle')" title="Свернуть боковое меню" aria-label="Свернуть">
          <img src="@/assets/images/arrow-up.svg" class="collapse-icon" alt="" />
        </button>
      </div>
      <img class="logo" src="@/assets/images/saqshy_logo.png" alt="Saqshy Logo" />
      <img class="logo logo--knb" src="@/assets/images/knb_logo.png" alt="KNB Logo" />

      <div class="primary-item primary-item--home" @click="go('/')">
        <div class="primary-left">
          <LucideIcon :size="20" strokeWidth="1.75" class="primary-icon"><g v-html="IconHome" /></LucideIcon>
          <div class="primary-text">{{ $t('sidebar.main') }}</div>
        </div>
      </div>

    <div v-if="showBook" class="primary-item" @click="toggleBook">
      <div class="primary-left">
        <LucideIcon :size="20" strokeWidth="1.75" class="primary-icon"><g v-html="IconBook" /></LucideIcon>
        <div class="primary-text">{{ $t('sidebar.kps') }}</div>
      </div>
      <div class="primary-right">
        <img
          src="@/assets/images/arrow-up.svg"
          alt="Arrow Icon"
          class="primary-arrow"
          :class="{ rotated: !isBookOpen }"
        />
      </div>
    </div>

    <transition name="fade">
      <div v-if="isBookOpen" class="menu">
        <div
          v-for="(item, idx) in visibleBookItems"
          :key="idx"
          class="menu-block"
        >
          <div
            class="menu-item"
            :class="{ active: isRouteActive(item.to) }"
            @click="onBookItemClick(item)"
            :title="plainText(item.i18n ? $t(item.i18n) : item.label)"
          >
            <div class="tree-container">
              <img src="@/assets/images/tree.svg" alt="Tree Icon" class="tree-icon"/>
            </div>
            <div class="menu-text" v-html="item.i18n ? $t(item.i18n) : item.label"></div>
          </div>
          <hr class="menu-sep" />
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="isDecisionOpen" class="menu">
        <div
          v-for="(item, idx) in visibleDecisionItems"
          :key="idx"
          class="menu-block"
        >
          <div
            class="menu-item"
            :class="{ active: isRouteActive(item.to) }"
            @click="onBookItemClick(item)"
            :title="plainText(item.i18n ? $t(item.i18n) : item.label)"
          >
            <div class="tree-container">
              <img src="@/assets/images/tree.svg" alt="Tree Icon" class="tree-icon"/>
            </div>
            <div class="menu-text" v-html="item.i18n ? $t(item.i18n) : item.label"></div>
          </div>
          <hr class="menu-sep" />
        </div>
      </div>
    </transition>

    <div v-if="canHousehold" class="primary-item" @click="toggleHousehold">
      <div class="primary-left">
        <LucideIcon :size="20" strokeWidth="1.75" class="primary-icon"><g v-html="IconWarehouse" /></LucideIcon>
        <div class="primary-text">{{ $t('sidebar.household') }}</div>
      </div>
      <div class="primary-right">
        <img
          src="@/assets/images/arrow-up.svg"
          alt="Arrow Icon"
          class="primary-arrow"
          :class="{ rotated: !isHouseholdOpen }"
        />
      </div>
    </div>

    <transition name="fade">
      <div v-if="isHouseholdOpen" class="menu">
        <div
          v-for="group in visibleHouseholdItems"
          :key="group.id || group.label"
          class="menu-group"
        >
          <div class="menu-group-header" @click="toggleGroup(group)">
            <div class="tree-container">
              <img src="@/assets/images/tree.svg" alt="Tree Icon" class="tree-icon"/>
            </div>
            <div class="menu-icon" v-if="group.icon">
              <LucideIcon :size="18" strokeWidth="1.5">
                <g v-html="group.icon"></g>
              </LucideIcon>
            </div>
            <div class="menu-text">{{ group.i18n ? $t(group.i18n) : group.label }}</div>
            <div class="group-arrow" v-if="group.children">
              <img
                src="@/assets/images/arrow-up.svg"
                alt="Arrow"
                class="primary-arrow small"
                :class="{ rotated: !group.isOpen }"
              />
            </div>
          </div>
          
          <transition name="fade">
            <div v-if="!group.children || group.isOpen" class="submenu">
              <div
                v-for="child in visibleHouseholdChildren(group)"
                :key="child.id || child.to || child.label"
                class="menu-item subitem"
                :class="{ active: isRouteActive(child.to) }"
                @click="onBookItemClick(child)"
              >
                <div class="tree-container">
                   <img src="@/assets/images/tree.svg" alt="Tree Icon" class="tree-icon"/>
                </div>
                <div class="menu-text small">{{ child.i18n ? $t(child.i18n) : child.label }}</div>
              </div>
            </div>
          </transition>
          <hr class="menu-sep" />
        </div>
      </div>
    </transition>

    <div 
      v-for="(cat, idx) in visibleExtraCategories" 
      :key="idx"
    >
      <div
        v-if="cat.children"
        class="primary-item"
        @click="toggleExtraCategory(cat)"
      >
        <div class="primary-left">
          <LucideIcon :size="20" strokeWidth="1.75" class="primary-icon"><g v-html="cat.iconSvg || IconBook" /></LucideIcon>
          <div class="primary-text">{{ cat.i18n ? $t(cat.i18n) : cat.label }}</div>
        </div>
        <div class="primary-right">
          <img
            src="@/assets/images/arrow-up.svg"
            alt="Arrow Icon"
            class="primary-arrow"
            :class="{ rotated: !cat.isOpen }"
          />
        </div>
      </div>
      <div v-else class="primary-item" @click="go(cat.to)">
        <div class="primary-left">
          <LucideIcon :size="20" strokeWidth="1.75" class="primary-icon"><g v-html="cat.iconSvg || IconBook" /></LucideIcon>
          <div class="primary-text">{{ cat.i18n ? $t(cat.i18n) : cat.label }}</div>
        </div>
      </div>

      <transition name="fade" v-if="cat.children">
        <div v-if="cat.isOpen" class="menu">
          <div
            v-for="(child, cIdx) in visibleCategoryChildren(cat)"
            :key="cIdx"
            class="menu-item"
            :class="{ active: isRouteActive(child.to) }"
            @click="onBookItemClick(child)"
          >
            <div class="tree-container">
              <img src="@/assets/images/tree.svg" alt="Tree Icon" class="tree-icon"/>
            </div>
            <div class="menu-text">{{ child.i18n ? $t(child.i18n) : child.label }}</div>
          </div>
        </div>
      </transition>
    </div>


    <div class="sidebar__footer">
      <div class="settings">
        <div class="settings-icon">
          <img src="@/assets/images/settings.svg" :alt="$t('sidebar.settings')">
        </div>
        <div class="settings-text">{{ $t('sidebar.settings') }}</div>
      </div>
      <hr class="footer-sep" />
      <div class="footer-caption">{{ $t('sidebar.footer', 'ИНТЕГРАЦИОННАЯ СИСТЕМА АВТОМАТИЗИРОВАННОГО УПРАВЛЕНИЯ САКШЫ') }}</div>
    </div>
  </div>
</template>

<script>
import LucideIcon from '@/components/common/LucideIcon.vue';
import { ensureCurrentUser, getCachedCurrentUser } from '@/api/user';
import { canAccessModule, canAccessPath, isAdmin as isAdminUser, MODULE_CHPO, MODULE_KPS, MODULE_HOUSEHOLD, MODULE_BSFP, MODULE_VIR, MODULE_MPO, moduleFromPath } from '@/access/armAccess';

const IconDashboard = '<rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>';
const IconPackage = '<path d="M16 16h.01"/><path d="M3.4 7.1a2 2 0 0 0-1 1.7v6.2a2 2 0 0 0 1 1.7l5.9 3.3a2 2 0 0 0 2 0l5.9-3.3a2 2 0 0 0 1-1.7V8.8a2 2 0 0 0-1-1.7L12.4 3.8a2 2 0 0 0-2 0l-7 3.3Z"/><path d="m11.5 12.3 8.7-5"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>';
const IconOperations = '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>';
const IconSpecial = '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>';
const IconReports = '<line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/>';

// Иконки верхнеуровневых пунктов сайдбара (Lucide-стиль, 24x24 viewBox).
const IconHome = '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>';
const IconBook = '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>';
const IconWarehouse = '<path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35a2 2 0 0 1 1.26-1.86l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"/><path d="M6 18h12"/><path d="M6 14h12"/><rect width="12" height="12" x="6" y="10"/>';
const IconMap = '<polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" x2="9" y1="3" y2="18"/><line x1="15" x2="15" y1="6" y2="21"/>';
const IconRadar = '<path d="M19.07 4.93A10 10 0 0 0 6.99 3.34"/><path d="M4 6h.01"/><path d="M2.29 9.62A10 10 0 1 0 21.31 8.35"/><path d="M16.24 7.76A6 6 0 1 0 17.93 14"/><path d="M12 18h.01"/><path d="M17.99 11.66A6 6 0 0 1 15.77 16.67"/><circle cx="12" cy="12" r="2"/><path d="m13.41 10.59 5.66-5.66"/>';
const IconActivity = '<path d="M6.5 6.5h11"/><path d="m21 21-1-1"/><path d="m3 3 1 1"/><path d="m18 22 4-4"/><path d="m2 6 4-4"/><path d="m3 10 7-7"/><path d="m14 21 7-7"/><circle cx="12" cy="12" r="3"/>';
const IconUsers = '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>';
const IconStar = '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>';

export default {
  name: "PlanSidebar",
  emits: ['toggle'],
  components: { LucideIcon },
  data() {
    return {
      currentUser: null,
      isDecisionOpen: false,
      isBookOpen: false,
      isHouseholdOpen: false,
      // По ТЗ 03.09.2026: все labels меню — через i18n-ключи в `i18n:`.
      // В шаблоне отображаются как `{{ $t(item.i18n) || item.label }}`.
      bookItems: [
        { label: 'Книга пограничной службы', i18n: 'sidebar.book.kps',  to: '/kps/map' },
        { label: 'Составление плана охраны', i18n: 'sidebar.book.chpo', to: '/chpo/decision-start' },
      ],
      decisionItems: [
        { label: 'Персонал',      i18n: 'sidebar.chpoSub.personnel', to: '/chpo/personnel' },
        { label: 'Приказы',       i18n: 'sidebar.chpoSub.orders',    to: '/chpo/orders' },
        { label: 'Планы',         i18n: 'sidebar.chpoSub.plans',     to: '/chpo/plan' },
        { label: 'Силы',          i18n: 'sidebar.chpoSub.forces',    to: '/chpo/forces' },
        { label: 'Карта',         i18n: 'sidebar.chpoSub.map',       to: '/chpo/map' },
        { label: 'Лист нагрузки', i18n: 'sidebar.chpoSub.workload',  to: '/chpo/workload' },
      ],
      householdItems: [
        // По ТЗ 10.09.2026: сверху — «Службы», под ней 11 подпунктов.
        // Каждый ведёт на /household/services/<code>, страница = Склад + 5 табов.
        {
          id: 'services',
          label: 'Службы', i18n: 'sidebar.wms.services',
          isOpen: false, icon: IconPackage,
          children: [
            { id: 'svc-pfs',   label: 'ПФС',           i18n: 'sidebar.wms.svcPfs',   to: '/household/services/pfs'   },
            { id: 'svc-ovs',   label: 'ОВС',           i18n: 'sidebar.wms.svcOvs',   to: '/household/services/ovs'   },
            { id: 'svc-kes',   label: 'КЭС',           i18n: 'sidebar.wms.svcKes',   to: '/household/services/kes'   },
            { id: 'svc-gsm',   label: 'ГСМ',           i18n: 'sidebar.wms.svcGsm',   to: '/household/services/gsm'   },
            { id: 'svc-svyaz', label: 'Связь',         i18n: 'sidebar.wms.svcSvyaz', to: '/household/services/svyaz' },
            { id: 'svc-asu',   label: 'АСУ',           i18n: 'sidebar.wms.svcAsu',   to: '/household/services/asu'   },
            { id: 'svc-rav',   label: 'РАВ',           i18n: 'sidebar.wms.svcRav',   to: '/household/services/rav'   },
            { id: 'svc-inzh',  label: 'ИНЖ',           i18n: 'sidebar.wms.svcInzh',  to: '/household/services/inzh'  },
            { id: 'svc-abts',  label: 'АБТС',          i18n: 'sidebar.wms.svcAbts',  to: '/household/services/abts'  },
            { id: 'svc-vet',   label: 'Ветеринарная',  i18n: 'sidebar.wms.svcVet',   to: '/household/services/vet'   },
            { id: 'svc-med',   label: 'Медицинская',   i18n: 'sidebar.wms.svcMed',   to: '/household/services/med'   },
          ]
        },
        {
          id: 'references',
          label: 'Справочники', i18n: 'sidebar.wms.references',
          isOpen: false, icon: IconPackage,
          children: [
            { id: 'nomenclature-types', label: 'Типы номенклатур', i18n: 'sidebar.wms.nomenclatureTypes', to: '/household/nomenclature-types' },
            { id: 'nomenclatures',      label: 'Номенклатуры',      i18n: 'sidebar.wms.nomenclatures',      to: '/household/nomenclatures' },
            { id: 'counterparties',     label: 'Контрагенты',       i18n: 'sidebar.wms.counterparties',     to: '/household/counterparties' },
            { id: 'warehouses',         label: 'Склады',            i18n: 'sidebar.wms.warehouses',         to: '/household/warehouses' },
          ]
        },
        {
          id: 'operations',
          label: 'Операции', i18n: 'sidebar.wms.operations',
          isOpen: false, icon: IconOperations,
          children: [
            { id: 'receipt',      label: 'Приход',       i18n: 'sidebar.wms.receipt',      to: '/household/receipt' },
            { id: 'consumption',  label: 'Расход',       i18n: 'sidebar.wms.consumption',  to: '/household/consumption' },
            { id: 'movement',     label: 'Перемещение',  i18n: 'sidebar.wms.movement',     to: '/household/movement' },
            { id: 'writeoff',     label: 'Списание',     i18n: 'sidebar.wms.writeoff',     to: '/household/writeoff' },
            { id: 'inventory',    label: 'Инвентаризация', i18n: 'sidebar.wms.inventory',  to: '/household/inventory' },
          ]
        },
        {
          id: 'special',
          label: 'Спец. функции', i18n: 'sidebar.wms.special',
          isOpen: false, icon: IconSpecial,
          children: [
            { id: 'expiry',       label: 'Сроки годности', i18n: 'sidebar.wms.expiry',       to: '/household/expiry' },
            { id: 'depreciation', label: 'Амортизация',    i18n: 'sidebar.wms.depreciation', to: '/household/depreciation' },
            { id: 'temp-storage', label: 'Врем. хранение', i18n: 'sidebar.wms.tempStorage',  to: '/household/temp-storage' },
            { id: 'weapon-issue', label: 'Выдача оружия',  i18n: 'sidebar.wms.weaponIssue',  to: '/household/weapon-issue' },
          ]
        },
        {
          id: 'reports',
          label: 'Отчеты', i18n: 'sidebar.wms.reports',
          isOpen: false, icon: IconReports,
          children: [
            { id: 'stock-report',    label: 'Остатки',    i18n: 'sidebar.wms.stockReport',    to: '/household/stock-report' },
            { id: 'movement-report', label: 'Движение',   i18n: 'sidebar.wms.movementReport', to: '/household/movement-report' },
            { id: 'statements',      label: 'Ведомости',  i18n: 'sidebar.wms.statements',     to: '/household/statements' },
          ]
        },
      ],
      currentExtraCategory: null,
      // Иконки для использования в шаблоне (exposed для v-html)
      IconHome, IconBook, IconWarehouse, IconMap, IconRadar, IconActivity, IconUsers, IconStar,
      extraCategories: [
        { label: 'СХЕМА УЧАСТКА', i18n: 'sidebar.mapScheme', to: '/map-scheme', iconSvg: IconMap },
        { label: 'ТСОГ', i18n: 'sidebar.tsog', to: '/tsog', iconSvg: IconRadar },
        {
          label: 'БСФП',
          i18n: 'sidebar.bsfp',
          isOpen: false,
          iconSvg: IconActivity,
          children: [
            { label: 'Журнал учета БП / Успеваемость', i18n: 'sidebar.bsfpSub.attendance', to: '/bsfp/attendance' },
            { label: 'План / Расписание',              i18n: 'sidebar.bsfpSub.schedule',   to: '/bsfp/schedule' },
            { label: 'База данных литературы',         i18n: 'sidebar.bsfpSub.literature', to: '/bsfp/literature' },
          ]
        },
        {
          label: 'ВИР',
          i18n: 'sidebar.vir',
          isOpen: false,
          iconSvg: IconUsers,
          children: [
            { label: 'Журнал учета БП / Успеваемость', i18n: 'sidebar.virSub.performance', to: '/vir/performance' },
            { label: 'План / Расписание',              i18n: 'sidebar.virSub.schedule',    to: '/vir/schedule' },
            { label: 'База данных литературы',         i18n: 'sidebar.virSub.literature',  to: '/vir/literature' },
          ]
        },
        { label: 'МПО', i18n: 'sidebar.mpo', to: '/mpo', iconSvg: IconStar },
        { label: 'ПОЛЬЗОВАТЕЛИ', i18n: 'sidebar.users', to: '/admin/users', iconSvg: IconUsers, adminOnly: true },
        // По ТЗ «Рабочие задачи» блок 6.2–6.5 — раздел «Справочники» с CRUD.
        {
          label: 'СПРАВОЧНИКИ',
          i18n: 'sidebar.dictionaries',
          iconSvg: IconBook,
          adminOnly: true,
          children: [
            { label: 'Воинские звания',           i18n: 'sidebar.dictSub.ranks',          to: '/settings/ranks' },
            { label: 'Должности',                 i18n: 'sidebar.dictSub.positions',      to: '/settings/positions' },
            { label: 'Категории военнослужащих',  i18n: 'sidebar.dictSub.userCategories', to: '/settings/user-categories' },
            { label: 'Типы СТПН',                 i18n: 'sidebar.dictSub.stpnTypes',      to: '/settings/stpn-types' },
            { label: 'КПС · Виды проверок',       i18n: 'sidebar.dictSub.checkTypes',     to: '/settings/check-types' },
            { label: 'КПС · Типы ТС',             i18n: 'sidebar.dictSub.vehicleTypes',   to: '/settings/vehicle-types' },
            { label: 'КПС · Типы питания',        i18n: 'sidebar.dictSub.mealTypes',      to: '/settings/meal-types' },
            { label: 'Типовой распорядок дня',    i18n: 'sidebar.dictSub.routineTemplate', to: '/settings/routine' },
          ],
        },
      ]
    };
  },
  computed: {
    armUser() {
      return this.currentUser || getCachedCurrentUser();
    },
    canChpo() {
      return canAccessModule(this.armUser, MODULE_CHPO);
    },
    canKps() {
      return canAccessModule(this.armUser, MODULE_KPS);
    },
    canHousehold() {
      return canAccessModule(this.armUser, MODULE_HOUSEHOLD);
    },
    canBsfp() {
      return canAccessModule(this.armUser, MODULE_BSFP);
    },
    canVir() {
      return canAccessModule(this.armUser, MODULE_VIR);
    },
    canMpo() {
      return canAccessModule(this.armUser, MODULE_MPO);
    },
    showBook() {
      // "Book" block contains shortcuts to CHPO/KPS.
      return this.canChpo || this.canKps;
    },
    visibleBookItems() {
      return this.bookItems.filter((it) => {
        if (!it?.to) return false;
        return canAccessPath(this.armUser, it.to);
      });
    },
    visibleDecisionItems() {
      return this.decisionItems.filter((it) => {
        if (!it?.to) return false;
        return canAccessPath(this.armUser, it.to);
      });
    },
    visibleHouseholdItems() {
      // IMPORTANT: do not spread/copy reactive groups, otherwise toggling `isOpen`
      // won't update UI reliably.
      return (this.householdItems || []).filter((group) => {
        if (!group) return false;
        if (!Array.isArray(group.children)) return true;
        return this.visibleHouseholdChildren(group).length > 0;
      });
    },
    visibleExtraCategories() {
      // Админ-меню («Пользователи», «Справочники») — по RBAC-роли ADMIN,
      // либо is_superuser / is_staff (обратная совместимость).
      const isAdmin = isAdminUser(this.armUser);
      // Remove "ВОЙСКОВОЕ ХОЗЯЙСТВО" from extraCategories as it's now handled separately
      return this.extraCategories
        .filter(cat => cat.label !== 'ВОЙСКОВОЕ ХОЗЯЙСТВО')
        .filter(cat => !cat.adminOnly || isAdmin)
        .filter((cat) => {
          if (cat.children && Array.isArray(cat.children)) {
            return this.visibleCategoryChildren(cat).length > 0;
          }
          if (!cat?.to) return false;
          if (cat.adminOnly) return isAdmin;
          return canAccessPath(this.armUser, cat.to);
        });
    },
  },
  async mounted() {
    try {
      this.currentUser = await ensureCurrentUser();
    } catch {
      this.currentUser = getCachedCurrentUser();
    }
  },
  methods: {
    toggleDecision() { this.isDecisionOpen = !this.isDecisionOpen },
    toggleBook() { this.isBookOpen = !this.isBookOpen },
    toggleHousehold() { this.isHouseholdOpen = !this.isHouseholdOpen },
    toggleGroup(group) { if (group.children) group.isOpen = !group.isOpen; else if (group.to) this.go(group.to); },
    toggleExtraCategory(cat) { if (cat.children) cat.isOpen = !cat.isOpen; },
    go(path) { if (path) this.$router.push(path) },
    onBookItemClick(item) { if (item && item.to) this.$router.push(item.to) },
    isRouteActive(path) { return !!path && this.$route.path === path },
    plainText(html) {
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    visibleCategoryChildren(cat) {
      if (!cat || !Array.isArray(cat.children)) return [];
      return cat.children.filter((ch) => ch?.to && canAccessPath(this.armUser, ch.to));
    },
    visibleHouseholdChildren(group) {
      if (!group || !Array.isArray(group.children)) return [];
      return group.children.filter((ch) => ch?.to && canAccessPath(this.armUser, ch.to));
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 100%;
  height: 100%;
  background: #12203b;
  border-right: 0.1rem solid #323b49;
  padding: 0 2rem 2rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  -ms-overflow-style: none;
  scrollbar-width: none;
}
.sidebar::-webkit-scrollbar {    
  width: 0;
  height: 0;
}

.logos-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.logo {
  width: 90%;
  height: auto;
}
.logo--knb {
  margin-bottom: 1rem;
}

.sidebar__topbar {
  width: 100%;
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.collapse-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  border: 0;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: rgba(18, 32, 59, 0.08);
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s ease;
  filter: invert(80%);
}

.primary-item--home {
  margin-top: 10px;
}

.collapse-icon {
  width: 18px;
  height: 18px;
  transform: rotate(-90deg);
  transition: transform 0.2s ease, filter 0.2s ease;
}
.collapse-btn:hover .collapse-icon {
  filter: invert(100%);
  transform: rotate(-90deg) translateX(-2px);
}

.primary-item {
  width: 100%;
  height: auto;
  min-height: 2.75rem;
  /* Use stable sizing to keep all primary blocks одинаковой толщины */
  padding: 0.75rem 0.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 0.625rem;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.primary-item:hover { background: rgba(255, 255, 255, 0.05); }

.primary-left { display: flex; align-items: center; gap: 0.625rem; flex: 1 1 auto; min-width: 0; }
.primary-icon { width: 1.25rem; height: 1.25rem; color: #fff; flex-shrink: 0; }
.primary-text {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;

  line-height: 1.2rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.primary-right { display: flex; align-items: center; }
.primary-arrow { width: 1.5rem; height: 1.5rem; transition: transform 0.2s ease; }
.primary-arrow.rotated { transform: rotate(180deg); }

.menu {
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.menu-block { display: flex; flex-direction: column; }
.menu-icon {
  margin-right: 0.75rem;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.menu-group { display: flex; flex-direction: column; }
.menu-group-header {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  border-radius: 0.625rem;
  transition: background-color 0.2s ease;
}
.menu-group-header:hover { background: rgba(255, 255, 255, 0.04); }

.group-arrow {
  margin-left: auto;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}

.primary-arrow.small {
  width: 1rem;
  height: 1rem;
}

.submenu {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding-left: 0.5rem;
}

.menu-sep {
  display: none;
}

.menu-item {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  border-radius: 0.625rem;
  transition: background-color 0.2s ease;
}
.menu-item:hover { background: rgba(255, 255, 255, 0.04); }
.menu-item.active { background: rgba(255, 255, 255, 0.1); }

.tree-container{ height: 100%; padding-left: 8px; justify-content: flex-start; align-items: flex-start; display: inline-flex; }
.tree-icon { width: 12px; height: 24px; visibility: hidden}

.menu-text {
  flex: 1 1 0;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3rem;
  letter-spacing: 0.01rem;
  padding: 6px 8px;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
.menu-text.small {
  font-size: 0.875rem;
  padding: 5px 8px;
  font-weight: 500;
}

.sidebar__footer {
  align-self: stretch;
  margin-top: auto;
}
.footer-sep {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  margin: 0.75rem 0;
}
.footer-caption {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  line-height: 1.4;
  text-transform: uppercase;
}

.settings { padding: 0.5rem 0; border-radius: 0.625rem; display: inline-flex; align-items: center; gap: 0.625rem; cursor: pointer; }
.settings:hover { background: rgba(255, 255, 255, 0.05); }
.settings-icon { width: 1.25rem; height: 1.25rem; }
.settings-text { color: #fff; font-size: 13px; font-weight: 600; letter-spacing: 0.02em; }

.fade-enter-active, .fade-leave-active { transition: all 0.25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(-5px); }
</style>
